<template>
<div class="mod-log">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="">
            <el-input v-model="dataForm.studentName" placeholder="姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-dict-select v-if="manageOrgIdFlag()" placeholder="选择机构" v-model="dataForm.orgId" type="orgList"></el-dict-select>
        </el-form-item>
        <el-form-item label="">
            <el-select v-model="dataForm.state" clearable placeholder="状态">
            <el-option label="正在进行" value="1"></el-option>
            <el-option label="已结束" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
            <el-select v-model="dataForm.courseClassType" clearable placeholder="课包类型">
                <el-option label="常规课" value="NORMAL"></el-option>
                <el-option label="营队课" value="CAMP"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button @click="rgetDataList()">查询</el-button>
        </el-form-item>
    </el-form>
    <el-row style="margin-bottom: 1rem">
        <el-col>
            <el-button type="info" @click="excel" v-if="isAuth('sys:courseDetail:export')">
                导出<i class="el-icon-download"></i>
            </el-button>
        </el-col>
    </el-row>
    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%">
        <el-table-column type="index" header-align="center" align="center" label="序号" :index="indexMethod" width="50">
        </el-table-column>
        <el-table-column prop="studentName" header-align="center" align="center" label="学生名称">
        </el-table-column>
        <el-table-column prop="totalAmount" header-align="center" align="center" label="缴费金额">
        </el-table-column>
        <el-table-column prop="courseAllNum" header-align="center" align="center" label="总课时">
        </el-table-column>
        <el-table-column prop="courseActualNum" header-align="center" align="center" label="课包课时">
        </el-table-column>
        <el-table-column prop="delivery" header-align="center" align="center" label="是否赠课">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.delivery" size="small">是
                </el-tag>
                <el-tag v-else size="small" type="danger">否</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="deliveryNum" header-align="center" align="center" label="赠课数量">
        </el-table-column>
        <el-table-column prop="consumeCourseNum" header-align="center" align="center" label="已上课时">
        </el-table-column>
        <el-table-column prop="courseLimit" header-align="center" align="center" label="剩余课时">
        </el-table-column>
        <el-table-column prop="state" width="80" header-align="center" align="center" label="状态">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.state === 2" size="small" type="warning">等待中
                </el-tag>
                <el-tag v-if="scope.row.state === 1 " size="small">正在进行
                </el-tag>
                <el-tag v-if="scope.row.state === 0" size="small" type="danger">已经结束</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="courseClassType" header-align="center" align="center" width="80" label="合约类型">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.courseClassType === 'NORMAL'" type="success" size="small" >常规课
                </el-tag>
                <el-tag v-if="scope.row.courseClassType === 'CAMP'" size="small">营队课</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="remark" header-align="center" align="center" width="80" label="合约备注">
            <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                    <p>{{ scope.row.remark }}</p>
                    <div slot="reference" class="name-wrapper">
                        <el-tag type="info" size="medium">{{ scope.row.remark }}</el-tag>
                    </div>
                </el-popover>
            </template>
        </el-table-column>
        <el-table-column prop="contractDate" header-align="center" align="center" width="80" label="合约时间">
        </el-table-column>
        <el-table-column header-align="center" align="center" width="180" label="操作">
            <template slot-scope="{ row }">
                <el-button v-if="isAuth('sys:courseDetail:update') && row.state !== 0" type="text" size="small" @click="addOrUpdateHandle(row.id)">
                    修改
                </el-button>
                <el-button v-if="isAuth('sys:courseDetail:update') && row.state !== 0" type="text" size="small" @click="endContractHandle(row)" >
                    结束合约
                </el-button>
                <el-button v-if="isAuth('sys:courseDetail:delete')" type="text" size="small" @click="deleteHandle(row)" style="color:#F56E6E">
                    删除
                </el-button>
            </template>
        </el-table-column>
        <el-table-column prop="creator" header-align="center" align="center" width="80" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" header-align="center" align="center" width="160" label="创建时间">
        </el-table-column>
        <el-table-column prop="updater" header-align="center" align="center" width="80" label="更新人">
        </el-table-column>
        <el-table-column prop="updateTime" header-align="center" align="center" width="160" label="更新时间">
        </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <update-course-num v-if="updateCourseNumVisible" ref="updateCourseNum" @refreshDataList="getDataList"></update-course-num>
</div>
</template>

<script>
import UpdateCourseNum from './coursesDetail-update'
import {
    getLoginToken
} from "../../../utils";
export default {
    data() {
        return {
            dataForm: {
                studentName: "",
                orgId: "",
                state: "",
                courseClassType: "",
            },
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            updateCourseNumVisible: false,
            selectionDataList: [],
        };
    },
    components: {
        UpdateCourseNum
    },
    created() {
        this.getDataList();
        this.doSearch();
    },
    methods: {
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            this.$http({
                url: this.$http.adornUrl("/sys/courseDetail/list"),
                method: "get",
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize,
                    studentName: this.dataForm.studentName,
                    orgId: this.dataForm.orgId,
                    state: this.dataForm.state,
                    courseClassType: this.dataForm.courseClassType,
                }),
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.dataList = data.page.list;
                    this.totalPage = data.page.totalCount;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
                this.dataListLoading = false;
            });
        },
        doSearch() {
            let that = this;
            document.onkeypress = function (e) {
                let keycode = document.all ? event.keyCode : e.which;
                if (keycode == 13) {
                    that.rgetDataList();
                }
            }
        },
        rgetDataList() {
            this.pageIndex = 1;
            this.getDataList();
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 结束合约
        endContractHandle(row) {
            let data = {}
            data.id = row.id
            data.userId = row.userId
            data.courseClassType = row.courseClassType
            data.state = row.state
            this.$confirm(`确定结束该合约?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.$http({
                        url: this.$http.adornUrl("sys/courseDetail/endContract"),
                        method: `post`,
                        data: this.$http.adornData(data)
                    }).then(({
                        data
                    }) => {
                        if (data && data.code === 0) {
                            this.$message({
                                message: "结束成功",
                                type: "success",
                            });
                            this.getDataList();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        // 删除
        deleteHandle(row) {
            let data = {}
            data.id = row.id
            data.userId = row.userId
            data.courseClassType = row.courseClassType
            data.state = row.state
            if (row.state === 0) {
                this.$confirm(`确定删除该合约?`, "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http({
                            url: this.$http.adornUrl("sys/courseDetail/deleteContract"),
                            method: "delete",
                            data: this.$http.adornData(data)
                        }).then(({
                            data
                        }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success",
                                });
                                this.getDataList();
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    })
                    .catch(() => {});
            }else{
                this.$message({
                    message: "请先结束该合约",
                    type: "warning",
                });
                return 
            }
        },
        addOrUpdateHandle(id) {
            this.updateCourseNumVisible = true
            this.$nextTick(() => {
                this.$refs.updateCourseNum.init(id)
            })
        },
        excel() {
            let url = this.$http.adornUrl("/sys/courseDetail/excel")
            let param = "?token=" + getLoginToken()
            param += "&orgId=" + this.dataForm.orgId
            param += "&courseClassType=" + this.dataForm.courseClassType
            param += "&state=" + this.dataForm.state
            param += "&studentName=" + this.dataForm.studentName
            url = url + param;
            window.location.href = url;
        },
    },
};
</script>
